

































import { Component, Mixins, Watch } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import GeneralModule from '@/store/modules/General';
import UserOnlineModule from '@/store/modules/Useronline';
import Table from '@/components/Table/Index.vue';
import UserOnlineBody from '@/components/Table/UserOnlineBody.vue';
import UserOnlineData from '@/data/UserOnlineData';
import utils from '@/services/utils';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import { Base64 } from 'js-base64';

@Component({
  components: {
    Table,
    UserOnlineBody,
  },
})
export default class UserOnlineView extends Mixins(ErrorHandleMixin) {
  UserOnlineInstance = getModule(UserOnlineModule, this.$store);

  GeneralInstance = getModule(GeneralModule, this.$store);

  utilsInstance = utils;

  TableHead = UserOnlineData.TableHead;

  partnerSelected = 'ALL';

  botOnline: any = [];

  playerOnlineList: any = [];

  playOnlineBefore: any = [];

  productList: any = [];

  token = utils.getUserPersistent().token;

  parent = utils.getUserPersistent().user._id;

  role = utils.getUserPersistent().user.role;

  ioConnect: any;

  footSum: any = 0;

  intervalUserOnline: any;

  async mounted() {
    this.GeneralInstance.toggleLoading(true);
    this.getUserOnline();
    this.repeatGetUserOnline();
  }

  beforeDestroy() {
    clearInterval(this.intervalUserOnline);
  }

  repeatGetUserOnline() {
    this.intervalUserOnline = setInterval(() => {
      this.getUserOnline();
    }, 10000);
  }

  @Watch('$i18n.locale')
  onLanguagChange() {
    if (this.$i18n.locale) {
      this.GeneralInstance.toggleLoading(true);
      this.getUserOnline();
    }
  }

  async getUserOnline() {
    const userOnline = await this.UserOnlineInstance.FetchPlayerOnline(this.$i18n.locale);
    this.footSum = 0;
    if (this.partnerSelected === 'ALL') {
      this.playerOnlineList = userOnline
        .sort((a: any, b: any) => b.totalUsers - a.totalUsers);
      this.playOnlineBefore = this.playerOnlineList;
      this.footSumery(this.playerOnlineList, this.partnerSelected);
    } else {
      this.playerOnlineList = userOnline
        .sort((a: any, b: any) => b.totalUsers - a.totalUsers);
      this.seletPartner(this.partnerSelected);
      this.footSumery(this.playerOnlineList, this.partnerSelected);
    }
    this.GeneralInstance.toggleLoading(false);
  }

  getAgentUser() {
    this.ioConnect.emit('getOnlineUsers', {}, (res: any) => {
      const decode: any = Base64.decode(res.data);
      const data = JSON.parse(decode);
      if (data) {
        this.getUserOnline(data.data);
        this.sortProvider(data.data);
      }
    });
    this.GeneralInstance.toggleLoading(false);
    setTimeout(() => {
      this.getAgentUser();
    }, 5000);
  }

  handleUserByDownline(data: any, item: string) {
    this.playerOnlineList = data.map((val: any) => ({
      amount: val.parentId.filter((id: any) => id === this.parent).length,
      name: val.name,
      partner: val.partner,
    })).filter((user: any) => user.amount);
    this.footSumery(this.playerOnlineList, item);
  }

  sortProvider(data: any) {
    if (!this.productList.length) {
      const user = Object.values(data);
      const provider = user.map((v: any) => v.partner);
      this.productList = [...new Set(provider)];
      this.productList.push('ALL');
      this.productList.sort();
      this.productList = this.productList.filter((v: any) => v !== '');
    }
  }

  async seletPartner(item: string) {
    this.GeneralInstance.toggleLoading(true);
    this.partnerSelected = item;
    const provider = item;
    if (item !== 'ALL') {
      this.playerOnlineList = await this.playerOnlineList
        .filter((v: any) => v.partner === provider);
    } else {
      this.playerOnlineList = this.playOnlineBefore;
    }
    if (this.role === 'AGENT') {
      this.handleUserByDownline(this.playerOnlineList, item);
    } else {
      this.footSumery(this.playerOnlineList, item);
    }
    this.GeneralInstance.toggleLoading(false);
  }

  footSumery(item: [], provider: string) {
    this.footSum = {
      coin: 0,
      user: 0,
      total: 0,
    };
    if (provider !== 'ALL') {
      const newUser = item.filter((data: any) => data.partner === provider);
      // eslint-disable-next-line no-return-assign
      newUser.forEach((data: any) => this.footSum += (data.totalUsers * 1));
    } else {
      // eslint-disable-next-line no-return-assign
      item.forEach((data: any) => {
        this.footSum.coin += data.totalCoinUsers * 1;
        this.footSum.user += data.totalUsers * 1;
        this.footSum.total += (data.totalCoinUsers * 1) + (data.totalUsers * 1);
      });
    }
  }
}
